import alfonsePic from "@/public/images/artists/alfonse.png";
import { Artist } from "@/types/types";

export const alfonse = {
  id: "287",
  name: "Alfonse",
  image: alfonsePic,
  description: `Alfonse has a smooth, melodic voice with a laid-back delivery, light grain, and a warm, rhythmic feel.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Falfonse-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Unprocessed", "Afrobeat", "RnB", "Airy"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 48,
        high: 68,
      },
      sweetSpot: 58,
    },
  },
} as const satisfies Artist;
